<div class="page-header">
  @if(!isMobile) {
    <h1 class="page-title">My Trucks</h1>
  } @else {
    <div class="results-count">
      @if (loading) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        Trucks: 
        <span class="ml-3" [class.no-results]="dataSource.data.length === 0">
          {{ dataSource.data.length | number }}
        </span>
      }
    </div>
  }

  <div class="header-actions">
    @if(!isMobile) {
      <div class="results-count">
        @if (loading) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          Trucks: 
          <span class="ml-3" [class.no-results]="dataSource.data.length === 0">
            {{ dataSource.data.length }}
          </span>
        }
      </div>
    }

    <button mat-icon-button class="refresh-button" (click)="getMyTrucks(true)" matTooltip="Refresh" [disabled]="loading">
      <mat-icon>refresh</mat-icon>
    </button>

    <button mat-icon-button class="create-button" (click)="createTruck()" matTooltip="Add New Truck" [disabled]="loading">
      <mat-icon>add</mat-icon>
    </button>

  </div>
</div>

<br />

<table mat-table [dataSource]="dataSource" matSort class="results-table">

  <!-- Mobile Column -->
  <ng-container matColumnDef="mobile">
    <th mat-header-cell *matHeaderCellDef></th>

    <td mat-cell *matCellDef="let truck">
      <div class="mobile-load-cell">

        <div class="mobile-actions">
          @if (!truck.visible) {
            <mat-icon class="hidden-icon" matTooltip="Hidden">
              visibility_off
            </mat-icon>
          }

          <button
            mat-icon-button
            [matMenuTriggerFor]="truckMenu"
            (click)="$event.stopPropagation()"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>

        <mat-menu #truckMenu="matMenu">
          <button mat-menu-item (click)="refreshTruck(truck)">
            <mat-icon>refresh</mat-icon>
            <span>Refresh</span>
          </button>

          <button mat-menu-item (click)="matchLoad(truck)">
            <mat-icon>search</mat-icon>
            <span>Match Loads</span>
          </button>

          <button mat-menu-item (click)="updateTruck(truck)">
            <mat-icon>edit</mat-icon>
            <span>Edit</span>
          </button>

          <button mat-menu-item (click)="copyTruck(truck)">
            <mat-icon>content_copy</mat-icon>
            <span>Copy</span>
          </button>

          <button mat-menu-item (click)="toggleVisibility(truck)">
            <mat-icon>
              {{ truck.visible ? 'visibility_off' : 'visibility' }}
            </mat-icon>
            <span>
              {{ truck.visible ? 'Hide' : 'Show' }}
            </span>
          </button>

          <button mat-menu-item (click)="deleteTruck(truck)">
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
          </button>
        </mat-menu>

        <div class="mobile-location-row">
          <mat-icon class="mobile-map-icon">location_on</mat-icon>

          <div class="location-text">
            {{ truck.origin_city | titlecase }}, {{ truck.origin_state }}
          </div>
        </div>

        <div class="mobile-details">
          Available:
          @if (truck.available_start_date === truck.available_end_date) {
            {{ truck.available_start_date | date:'MM/dd' }}
          } @else {
            {{ truck.available_start_date | date:'MM/dd' }} -
            {{ truck.available_end_date | date:'MM/dd' }}
          }
        </div>

        <div class="mobile-details">
          Max Weight: {{ truck.max_weight | number }} lbs
        </div>

        <div class="mobile-details">
          Axles: {{ truck.axle_count }}
        </div>

        <div class="mobile-details">
          Well: {{ toFeetAndInches(truck.well_length) }}
        </div>

        <div class="mobile-details">
          Carrier: {{ truck.carrier_name }}
        </div>

        <div class="mobile-details">
          Age: {{ formatAge(truck.refreshed_since) }}
        </div>

      </div>
    </td>
  </ng-container>

  <!-- Desktop Columns -->

  <ng-container matColumnDef="refreshed_since">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Age</th>
    <td mat-cell *matCellDef="let element">{{ formatAge(element.refreshed_since) }}</td>
  </ng-container>

  <ng-container matColumnDef="available_start_date">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Available</th>
    <td mat-cell *matCellDef="let element">
      @if(element.available_start_date === element.available_end_date) {
        {{ element.available_start_date | date: 'MM/dd' }}
      } @else {
        {{ element.available_start_date | date: 'MM/dd' }} -
        {{ element.available_end_date | date: 'MM/dd' }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="origin_city">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Origin</th>
    <td mat-cell *matCellDef="let element">{{ element.origin_city }}</td>
  </ng-container>

  <ng-container matColumnDef="origin_state">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
    <td mat-cell *matCellDef="let element">{{ element.origin_state }}</td>
  </ng-container>

  <ng-container matColumnDef="axle_count">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Axle Count</th>
    <td mat-cell *matCellDef="let element">{{ element.axle_count }}</td>
  </ng-container>

  <ng-container matColumnDef="max_weight">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Max Weight</th>
    <td mat-cell *matCellDef="let element">{{ element.max_weight | number}}</td>
  </ng-container>

  <ng-container matColumnDef="carrier_name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Carrier</th>
    <td mat-cell *matCellDef="let element">{{ element.carrier_name }}</td>
  </ng-container>

  <ng-container matColumnDef="reference">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Reference</th>
    <td mat-cell *matCellDef="let element">{{ element.reference }}</td>
  </ng-container>

  <ng-container matColumnDef="visible">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Visible</th>
    <td mat-cell *matCellDef="let element">{{ element.visible ? 'Yes' : 'No' }}</td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td mat-cell *matCellDef="let element">
      @if (element.expired) {
        <mat-chip>Expired</mat-chip>
      }

      <button
        mat-icon-button
        [matMenuTriggerFor]="truckMenu"
        (click)="$event.stopPropagation()"
      >
        <mat-icon>more_vert</mat-icon>
      </button>

      <mat-menu #truckMenu="matMenu">
        <button mat-menu-item (click)="refreshTruck(element)">
          <mat-icon>refresh</mat-icon>
          <span>Refresh</span>
        </button>

        <button mat-menu-item (click)="matchLoad(element)">
          <mat-icon>search</mat-icon>
          <span>Match Loads</span>
        </button>

        <button mat-menu-item (click)="updateTruck(element)">
          <mat-icon>edit</mat-icon>
          <span>Edit</span>
        </button>

        <button mat-menu-item (click)="copyTruck(element)">
          <mat-icon>content_copy</mat-icon>
          <span>Copy</span>
        </button>

        <button mat-menu-item (click)="toggleVisibility(element)">
          <mat-icon>
            {{ element.visible ? 'visibility_off' : 'visibility' }}
          </mat-icon>
          <span>
            {{ element.visible ? 'Hide' : 'Show' }}
          </span>
        </button>

        <button mat-menu-item (click)="deleteTruck(element)">
          <mat-icon>delete</mat-icon>
          <span>Delete</span>
        </button>
      </mat-menu>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" [hidden]="dataSource.data.length === 0"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    class="clickable-row"
    [class.inactive-row]="!row.visible"
    (click)="openTruckDialog(row)"
  ></tr>

  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="displayedColumns.length">
      No trucks found.
    </td>
  </tr>
</table>

<br />

<mat-paginator
  [style.display]="dataSource.data.length === 0 ? 'none' : ''"
  [pageSize]="itemsPerPage"
  [pageSizeOptions]="[10, 25, 50]"
  showFirstLastButtons>
</mat-paginator>